export default {"src":"/_next/static/media/tax-plan.ce156022.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};